import { Routes } from 'common/constants/routes';

import { _request, APIBaseResponse, APIMethod } from '../';
import { APISuiteGetEntityParams } from '../ApplicationSuites/ApplicationSuitesApiTypeDefs';

const APIKEYS_PATH_PREFIX = 'apikeys';
const SUITES_PATH_PREFIX = '/applicationsuites';

type APIApiKeyPostParams = {
    name: string;
    suiteId: string;
};
type APIApiKeyPostResponse = APIBaseResponse<{
    value: string;
}>;

type APIApiKeyDeleteParams = {
    id: string;
    name: string;
};

type APIApiKeyDeleteResponse = {
    error: string | null;
    success: boolean;
    data: null;
};

type APIGetApiKeysBySuiteResponse = APIBaseResponse<
    Array<{
        applicationSuiteId: string;
        name: string;
        value: string;
        isAdmin: boolean;
    }>
>;

export const APIKeyDelete: APIMethod<APIApiKeyDeleteParams, APIApiKeyDeleteResponse> = (params) => (
    _request('DELETE', `${SUITES_PATH_PREFIX}/${params.id}/${APIKEYS_PATH_PREFIX}/${params.name}`)
);

export const APIApiKeyPost: APIMethod<APIApiKeyPostParams, APIApiKeyPostResponse> = (params) => (
    _request<APIApiKeyPostResponse>('POST', `${SUITES_PATH_PREFIX}/${params.suiteId}/${APIKEYS_PATH_PREFIX}`, {
        name: params.name,
        applicationSuiteId: params.suiteId,
    })
);

export const APIGetApiKeysBySuite: APIMethod<APISuiteGetEntityParams, APIGetApiKeysBySuiteResponse> = (params) => (
    _request<APIGetApiKeysBySuiteResponse>('GET', `${SUITES_PATH_PREFIX}/${params.id}/${Routes.ApiKeys}`, undefined, params.signal)
);
